<div class="c-magicbagReward">
  <div
    class="c-magicbagReward__background"
    theming
    themingGroup="magicbag"
    themingAsset="reward-background"
    [themingOverride]="magicBagRewardModalData?.properties?.assets">
    <div
      class="c-magicbagReward__info"
      data-testid="magicbag-reward-info">
      <slotcom-display [classes]="['c-display--auto', 'c-display--magicbag', 'c-display--magicbag--reward']">
        <div
          displayIcon
          displayIconPos="left"
          class="c-display--coin"></div>
        <span>{{ magicBagRewardModalData?.reward?.credits | number: '1.0-0' : ('common.culture' | translate) }}</span>
      </slotcom-display>

      <slotcom-button
        class="c-button--pink"
        data-testid="magicbag-reward-button"
        (safeClick)="closeModal()"
        audioType="reward">
        {{
          magicBagRewardModalData.properties.buttonText[lang]
            ? magicBagRewardModalData.properties.buttonText[lang]
            : ('home.buttons.enjoy-it' | translate | uppercase)
        }}
      </slotcom-button>
    </div>
  </div>
</div>
